import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { RedBookVehicleUsedPriceCalculatedResponse } from '../../../../types/redbook';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getRedBookVehicleUsedPriceCalculated } from '../../requests/getRedBookVehicleUsedPriceCalculated';

export const useRedBookVehicleUsedPriceCalculated = (
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<RedBookVehicleUsedPriceCalculatedResponse> | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      'red-book-vehicle-used-price-calculated',
      params,
    ],
    queryFn: () => getRedBookVehicleUsedPriceCalculated(constructGet, params),
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'redBookData'), ...rest };
};
